import * as ActionTypes from '../../actions'
import {
    Action,
    TurnViolations
} from "../../types";
import semiCircleDonutConfig from "../../highchartsConfigDefault/circleDonutConfig";

const defaultState = {
    isLoading: true,
    hasError: false,
    violatorsPercentage: 0,
    chart: {}
};

export default function(state: TurnViolations = defaultState, action: Action) {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.FETCH_TRAFFIC_DETAILS: {

            return {
                ...state,
                isLoading: true,
                hasError: false
            };
        }
        case ActionTypes.FETCH_TRAFFIC_DETAILS_SUCCESS: {
            const { chart, violatorsPercentage } = payload;
            const { series, title } = chart;

            return {
                isLoading: false,
                hasError: false,
                violatorsPercentage,
                chart: {
                    donut: {
                        config: semiCircleDonutConfig().initializeWithOptions({
                            // chart: {
                            //     height: '140px'
                            // },
                            series,
                            title,
                            tooltip: {
                                pointFormat: '<b>{point.percentage:.1f}%</b>',
                                enabled: false
                            },
                        }),
                        show: true
                    }
                }
            };
        }
        case ActionTypes.FETCH_TRAFFIC_DETAILS_FAILURE: {

            return {
                ...state,
                isLoading: false,
                hasError: true
            };
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard/trafficDetails.ts